// extracted by mini-css-extract-plugin
export default {"select":"EditRank_select__gCKOX","bottom":"EditRank_bottom__Tit6A","badge":"EditRank_badge__7drx2"};